// @ts-nocheck

import React, { useContext, useCallback, useState, useEffect } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import globalFormStyles from "../global.formElements.module.scss";
import { CheckboxProps } from "./Checkbox.props";
import styles from "./Checkbox.module.scss";
import FieldMessage from "../FieldMessage";

import { FormContext, useFormField } from "../../Form";

/**
 * @deprecated Use `import { Checkbox } from capitalrx-components-2.0/lib/forms` instead.
 */
export const Checkbox: React.FC<CheckboxProps> = (props: CheckboxProps): JSX.Element => {
  const {
    id,
    label,
    name,
    disabled,
    large,
    containerClassName,
    value,
    validate,
    onChange,
    isChecked = false,
    inputClassName,
    indeterminate = false,
    isLoading,
    helperText,
    checkboxWrapperClassName,
  } = props;

  const { register, formState } = useContext(FormContext);
  const { errors, isFormLoading } = formState;

  const [selected, setSelected] = useState(isChecked);

  const fieldValue = useFormField(name || "");

  useEffect(() => {
    if (value !== undefined) {
      if ((fieldValue && fieldValue === value) || (Array.isArray(fieldValue) && fieldValue?.includes(value))) {
        setSelected(true);
      } else {
        setSelected(false);
      }
    }
  }, [fieldValue]);

  useEffect(() => {
    setSelected(isChecked);
  }, [isChecked]);

  const registerField = register(name || "", validate);

  // name is technically optional, but always injected by CheckboxGroup.
  if (!name || !register) {
    throw new Error("Component requires name");
  }

  let isInvalid = undefined;
  if (errors && Object.keys(errors)?.length) {
    isInvalid = name ? errors[name] : undefined;
  }

  const checkboxContainerClass = cn(
    globalFormStyles["form-field-container"],
    globalFormStyles["field-wrapper"],
    styles["checkbox-container"],
    containerClassName,
  );

  const checkboxWrapperClass = cn(
    styles["checkbox"],
    { [styles["checkbox-lg"]]: large },
    { [styles["checkbox-disabled"]]: disabled },
    { [styles["checkbox-invalid"]]: isInvalid !== undefined },
    checkboxWrapperClassName,
  );

  const checkboxIndicator = cn(
    { [styles["checkbox-checkmark"]]: !indeterminate },
    { [styles["checkbox-indeterminate"]]: indeterminate },
    { [styles["checkbox-invalid"]]: isInvalid !== undefined },
    inputClassName,
  );

  const handleInputChange = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>): void => {
      setSelected(ev.target.checked);
      registerField.onChange(ev);

      onChange && onChange(ev);
    },
    [onChange],
  );

  let component = null;

  if (isLoading || isFormLoading) {
    component = <Skeleton height={20} width={150} />;
  } else {
    component = (
      <label id={`checkbox-label-${id}`} className={checkboxWrapperClass}>
        <input
          {...registerField}
          aria-invalid={isInvalid ? true : false}
          aria-label={label}
          id={id}
          data-testid={`test__${id}`}
          type="checkbox"
          disabled={disabled}
          value={value}
          onChange={handleInputChange}
          checked={selected}
        />
        <span data-testid={`test__checkbox-${id}`} className={checkboxIndicator}></span>
        <span>{label}</span>
      </label>
    );
  }

  return (
    <span className={checkboxContainerClass}>
      {component}
      {helperText && (
        <FieldMessage id={id || name} helperText={helperText} errors={isInvalid ? errors : undefined} name={name} isLoading={isLoading} />
      )}
    </span>
  );
};

/**
 * @deprecated
 */
export default Checkbox;
